import uniqueId from 'lodash/uniqueId';
import cloneDeep from 'lodash/cloneDeep';
import axios from 'axios';
import api from '@src/api';

export const state = {
  allWorkouts: [],
  allWorkoutsTrueSource: [],
  workoutDetails: {},
  workoutModel: null,
  selectedWorkout: null,
  isLibraryWorkout: false,
  initialLibraryWorkout: null,
  duplicateCircuitError: null,
  timeFilterOpts: [
    { label: '< 15 min', range: { min: 0, max: 900 } },
    { label: '15-30 min', range: { min: 900, max: 1800 } },
    { label: '30-45 min', range: { min: 1800, max: 2700 } },
    { label: '45-60 min', range: { min: 2700, max: 3600 } },
  ],
  hasUnsavedChanges: false,
  workoutFilter: {},
};

export const getters = {
  hasInvalidWorkout: (state) => {
    let invalidWorkout = false;
    if (state.selectedWorkout) {
      if (
        state.selectedWorkout.isCustom ||
        state.selectedWorkout.programWorkout_id
      ) {
        if (
          !state.selectedWorkout.circuits ||
          !state.selectedWorkout.circuits.length > 0
        ) {
          invalidWorkout = true;
        }
        state.selectedWorkout.circuits.forEach((circuit, index) => {
          if (!circuit.exercises || !circuit.exercises.length > 0) {
            invalidWorkout = true;
          }
        });
      }
    }
    return invalidWorkout;
  },
  hasUnsavedChanges: (state) => {
    return state.hasUnsavedChanges;
  },
};

export const mutations = {
  setAllWorkouts(state, value) {
    state.allWorkouts = value;
  },
  setHasChanges(state, value) {
    state.hasUnsavedChanges = value;
  },
  setAllWorkoutsTrueSource(state, value) {
    state.allWorkoutsTrueSource = value;
  },
  setCreateWorkout(state, value) {
    state.allWorkouts.unshift(value);
    state.allWorkoutsTrueSource = state.allWorkouts;
  },
  setWorkoutDetails(state, value) {
    const workoutClone = cloneDeep(state.workoutDetails);
    workoutClone[value._id] = value;
    state.workoutDetails = workoutClone;
  },
  setUpdateWorkoutItem(state, value) {
    const i = state.allWorkouts.findIndex((item) => item._id === value._id);
    state.allWorkouts[i] = value;
    state.selectedWorkout = value;

    const j = state.allWorkoutsTrueSource.findIndex(
      (item) => item._id === value._id
    );
    state.allWorkoutsTrueSource[j] = value;
  },
  setDeleteWorkoutItem(state, value) {
    const i = state.allWorkouts.findIndex((item) => item._id === value._id);
    state.allWorkouts.splice(i, 1);

    const j = state.allWorkoutsTrueSource.findIndex(
      (item) => item._id === value._id
    );
    state.allWorkoutsTrueSource.splice(j, 1);
  },
  setUpdateWorkoutTitle(state, value) {
    const workoutClone = cloneDeep(state.selectedWorkout);
    workoutClone.label = value;
    state.selectedWorkout = workoutClone;
  },
  setUpdateWorkoutDescription(state, value) {
    const workoutClone = cloneDeep(state.selectedWorkout);
    workoutClone.description = value;
    state.selectedWorkout = workoutClone;
  },
  setUpdateWorkoutMuscleGroup(state, value) {
    const workoutClone = cloneDeep(state.selectedWorkout);
    workoutClone.muscleGroups.push({
      muscleGroup_id: value._id,
      label: value.label,
    });
    state.selectedWorkout = workoutClone;
  },
  setRemoveWorkoutMuscleGroup(state, value) {
    const i = state.selectedWorkout.muscleGroups.findIndex(
      (item) => item.muscleGroup_id === value
    );
    state.selectedWorkout.muscleGroups.splice(i, 1);
  },
  setUpdateWorkoutDifficulty(state, value) {
    const workoutClone = cloneDeep(state.selectedWorkout);
    workoutClone.exerciseDifficulty = {
      exerciseDifficulty_id: value._id,
      label: value.label,
    };
    state.selectedWorkout = workoutClone;
  },
  setAddWorkoutCircuit(state, value) {
    if (value && value.index !== undefined) {
      const index = value.index;
      const workoutClone = cloneDeep(state.selectedWorkout);
      workoutClone.circuits.splice(index, 0, value.circuit);
      state.selectedWorkout = workoutClone;
    } else {
      const workoutClone = cloneDeep(state.selectedWorkout);
      workoutClone.circuits.push(value);
      state.selectedWorkout = workoutClone;
    }
  },
  setUpdateWorkoutDuration(state, value) {
    const workoutClone = cloneDeep(state.selectedWorkout);
    workoutClone.timeToComplete = value;
    state.selectedWorkout = workoutClone;
  },
  setSelectedWorkout(state, value) {
    state.selectedWorkout = value;
  },
  setUpdateWorkoutExerciseSet(state, value) {
    const workoutClone = cloneDeep(state.selectedWorkout);
    const sets =
      workoutClone.circuits[value.circuitIndex].exercises[value.exerciseIndex]
        .setDirections;
    value.type === 'add' ? sets.push(value.set) : sets.pop();
    state.selectedWorkout = workoutClone;
  },
  setUpdateWorkoutExerciseSetReps(state, value) {
    const workoutClone = cloneDeep(state.selectedWorkout);
    const circuit = workoutClone.circuits[value.circuitIndex];
    const exercise = circuit.exercises[value.exerciseIndex];
    const set = exercise.setDirections[value.exerciseSetIndex];
    set.reps = value.count;
    state.selectedWorkout = workoutClone;
  },
  setUpdateWorkoutExerciseSetTime(state, value) {
    const workoutClone = cloneDeep(state.selectedWorkout);
    const circuit = workoutClone.circuits[value.circuitIndex];
    const exercise = circuit.exercises[value.exerciseIndex];
    const set = exercise.setDirections[value.exerciseSetIndex];
    set.time = value.count;
    state.selectedWorkout = workoutClone;
  },
  setUpdateWorkoutExerciseSetWeight(state, value) {
    const workoutClone = cloneDeep(state.selectedWorkout);
    const circuit = workoutClone.circuits[value.circuitIndex];
    const exercise = circuit.exercises[value.exerciseIndex];
    const set = exercise.setDirections[value.exerciseSetIndex];
    set.weight = value.count;
    state.selectedWorkout = workoutClone;
  },
  setUpdateWorkoutExerciseSetRest(state, value) {
    const workoutClone = cloneDeep(state.selectedWorkout);
    const circuit = workoutClone.circuits[value.circuitIndex];
    const exercise = circuit.exercises[value.exerciseIndex];
    const set = exercise.setDirections[value.exerciseSetIndex];
    set.afterSetRest = value.count;
    state.selectedWorkout = workoutClone;
  },
  setUpdateWorkoutCircuitReps(state, value) {
    const workoutClone = cloneDeep(state.selectedWorkout);
    const circuit = workoutClone.circuits[value.circuitIndex];
    circuit.circuitReps = value.count;
    state.selectedWorkout = workoutClone;
  },
  setRemoveWorkoutCircuit(state, value) {
    const workoutClone = cloneDeep(state.selectedWorkout);
    workoutClone.circuits.splice(value, 1);
    state.selectedWorkout = workoutClone;
  },
  setRemoveWorkoutCircuitExercise(state, value) {
    const workoutClone = cloneDeep(state.selectedWorkout);
    workoutClone.circuits[value.circuitIndex].exercises.splice(
      value.exerciseIndex,
      1
    );
    state.selectedWorkout = workoutClone;
  },
  setMoveWorkoutCircuitUp(state, value) {
    const workoutClone = cloneDeep(state.selectedWorkout);
    const prevIndex = value.index - 1;
    state.selectedWorkout.circuits = swapCircuits(
      workoutClone.circuits,
      value.index,
      prevIndex
    );
  },
  setMoveWorkoutCircuitDown(state, value) {
    const workoutClone = cloneDeep(state.selectedWorkout);
    const nextIndex = value.index + 1;
    state.selectedWorkout.circuits = swapCircuits(
      workoutClone.circuits,
      value.index,
      nextIndex
    );
  },
  setMoveWorkoutExerciseUp(state, value) {
    const circuitClone = cloneDeep(
      state.selectedWorkout.circuits[value.circuitIndex]
    );
    const prevIndex = value.exerciseIndex - 1;
    state.selectedWorkout.circuits[
      value.circuitIndex
    ].exercises = swapExercises(
      circuitClone.exercises,
      value.exerciseIndex,
      prevIndex
    );
  },
  setMoveWorkoutExerciseDown(state, value) {
    const circuitClone = cloneDeep(
      state.selectedWorkout.circuits[value.circuitIndex]
    );
    const nextIndex = value.exerciseIndex + 1;
    state.selectedWorkout.circuits[
      value.circuitIndex
    ].exercises = swapExercises(
      circuitClone.exercises,
      value.exerciseIndex,
      nextIndex
    );
  },
  setAddWorkoutCircuitLabel(state, value) {
    const workoutClone = cloneDeep(state.selectedWorkout);
    const circuit = workoutClone.circuits[value.circuitIndex];
    circuit.label = value.label;
    state.selectedWorkout = workoutClone;
  },
  setAddWorkoutCircuitDetails(state, value) {
    const workoutClone = cloneDeep(state.selectedWorkout);
    const circuit = workoutClone.circuits[value.circuitIndex];
    if (value.type === 'intro') {
      circuit.trainerFeedback.intro.text = value.text;
    } else if (value.type === 'fitnessType') {
      circuit.fitness_types = value.text;
    } else {
      circuit.trainerFeedback.outro.text = value.text;
    }
    state.selectedWorkout = workoutClone;
  },
  setAddWorkoutCircuitExercise(state, value) {
    const workoutClone = cloneDeep(state.selectedWorkout);
    const circuit = workoutClone.circuits[value.circuitIndex];
    const exercise = value.exercise;
    exercise.setDirections = value.defaultSet;
    circuit.exercises.push(exercise);
    state.selectedWorkout = workoutClone;
  },
  setAddUniqueId(state) {
    const workoutClone = cloneDeep(state.selectedWorkout);
    workoutClone.circuits.forEach((circuit) => {
      circuit.exercises.forEach((exercise) => {
        exercise.uniqueKey = uniqueId('ex_');
      });
    });
    state.selectedWorkout = workoutClone;
  },
  setWorkoutModel(state, value) {
    state.workoutModel = value;
  },
  setIsLibraryWorkout(state, value) {
    state.isLibraryWorkout = value;
  },
  setInitialLibraryWorkout(state, value) {
    state.initialLibraryWorkout = value;
  },
  setDuplicateCircuitError(state, value) {
    state.duplicateCircuitError = value;
  },
  setWorkoutFilter(state, value) {
    state.workoutFilter = value;
  },
};

export const actions = {
  getAllWorkouts(ctx, { orgId, trainerId, userId = 0, page = 1 }) {
    if (orgId !== undefined && trainerId !== undefined) {
      const url = api.URL_GET_ALL_WORKOUTS.replace(':orgID', orgId)
        .replace(':trainerID', trainerId)
        .replace(':userID', userId)
        .replace(':page', page);

      return axios
        .get(url)
        .then((res) => {
          const result = [
            ...new Set([...state.allWorkouts, ...res.data.programWorkouts]),
          ];
          ctx.commit('setAllWorkouts', result);
          ctx.commit('setAllWorkoutsTrueSource', result);
          return res.data;
        })
        .catch((err) => {
          console.warn(err);
        });
    } else {
      console.error(
        `invalid params (orgId, trainerId) : (${orgId}, ${trainerId})`
      );
    }
  },

  getWorkout(ctx, { workoutId, orgId, trainerId }) {
    if (
      workoutId !== undefined &&
      orgId !== undefined &&
      trainerId !== undefined
    ) {
      if (!ctx.state.workoutDetails[workoutId]) {
        const url = api.URL_GET_WORKOUT.replace(':workoutID', workoutId)
          .replace(':orgID', orgId)
          .replace(':trainerID', trainerId);

        return axios
          .get(url)
          .then((res) => {
            ctx.commit('setWorkoutDetails', res.data.programWorkout);
            return res.data;
          })
          .catch((err) => {
            console.warn(err);
          });
      } else {
        return ctx.state.workoutDetails[workoutId];
      }
    } else {
      console.error(
        `invalid params (workoutId, orgId, trainerId) : (${workoutId}, ${orgId}, ${trainerId})`
      );
    }
  },

  createWorkout(ctx, { workoutObj }) {
    if (isPayloadValid(workoutObj)) {
      const url = api.URL_CREATE_WORKOUT.replace(':orgID', workoutObj.org_id)
        .replace(':trainerID', workoutObj.trainer_id)
        .replace(':userID', workoutObj.user_id);

      // Minimum data check
      if (workoutObj.label !== undefined) {
        const requestPayload = { programWorkout: workoutObj };

        return axios
          .put(url, requestPayload)
          .then((res) => {
            if (res.data.error) {
              console.error('Error: ', res.data.error);
            } else {
              ctx.commit('setCreateWorkout', res.data.programWorkout);
              return res.data;
            }
          })
          .catch((err) => {
            console.warn(err);
          });
      } else {
        console.error(
          'workoutObj must contain the following properties "label"',
          workoutObj
        );
      }
    } else {
      logError(workoutObj);
    }
  },

  updateWorkout(ctx, { workoutObj }) {
    if (isPayloadValid(workoutObj)) {
      const url = api.URL_UPDATE_WORKOUT.replace(':workoutID', workoutObj._id)
        .replace(':orgID', workoutObj.org_id)
        .replace(':trainerID', workoutObj.trainer_id)
        .replace(':userID', workoutObj.user_id);

      // Minimum data check for obj
      if (workoutObj.label !== undefined) {
        const requestPayload = { programWorkout: workoutObj };
        return axios
          .post(url, requestPayload)
          .then((res) => {
            ctx.commit('setUpdateWorkoutItem', res.data.programWorkout);
            return res.data;
          })
          .catch((err) => {
            console.warn(err);
          });
      } else {
        console.error(
          'workoutObj must contain the following properties to be a valid replacement [trainer_id, org_id, user_id, label, replace]',
          workoutObj
        );
      }
    } else {
      logError(workoutObj);
    }
  },

  deleteWorkout(ctx, { workoutObj }) {
    if (isPayloadValid(workoutObj)) {
      const url = api.URL_DELETE_WORKOUT.replace(':workoutID', workoutObj._id)
        .replace(':orgID', workoutObj.org_id)
        .replace(':trainerID', workoutObj.trainer_id)
        .replace(':userID', workoutObj.user_id);

      return axios
        .delete(url)
        .then((res) => {
          return res.data;
        })
        .catch((err) => {
          console.warn(err);
        });
    } else {
      logError(workoutObj);
    }
  },

  getWorkoutShape(ctx, { orgId, trainerId, userId = 0 }) {
    if (orgId !== undefined && trainerId !== undefined) {
      const url = api.URL_GET_WORKOUT_SHAPE.replace(':orgID', orgId)
        .replace(':trainerID', trainerId)
        .replace(':userID', userId);

      return axios
        .get(url)
        .then((res) => {
          ctx.commit('setWorkoutModel', res.data.programWorkout);
          return res.data;
        })
        .catch((err) => {
          console.warn(err);
        });
    } else {
      console.error(
        `invalid params (orgId, trainerId) : (${orgId}, ${trainerId})`
      );
    }
  },

  setHasChanges(ctx, { changesValue }) {
    ctx.commit('setHasChanges', changesValue);
  },
};

// Private Helpers

function isPayloadValid(obj) {
  if (typeof obj.timeToComplete === 'string') {
    console.error(`Workout property 'timeToComplete' should be an Integer.`);
  }

  // Minimum data check for payload
  return (
    obj !== undefined &&
    obj.trainer_id !== undefined &&
    obj.org_id !== undefined &&
    obj.user_id !== undefined &&
    typeof obj.timeToComplete !== 'string'
  );
}

function logError(workoutObj) {
  console.error(
    `Invalid Params: (workoutObj, trainer_id, org_id, user_id) : (${workoutObj}, ${workoutObj.trainer_id}, ${workoutObj.org_id}, ${workoutObj.user_id})`
  );
}

function swapCircuits(arr, index1, index2) {
  [arr[index1], arr[index2]] = [arr[index2], arr[index1]];
  return arr;
}

function swapExercises(arr, index1, index2) {
  [arr[index1], arr[index2]] = [arr[index2], arr[index1]];
  return arr;
}
